import React from "react";
import { LegalDocument } from "../../features/members/legal-documents";

interface LegalDocumentViewProps {
  document: LegalDocument;
}

/**
 * Read-only renderer for a platform-standard legal document (Terms of Service, Privacy Policy).
 * Shared by the public, shareable document page so members can read what they consent to.
 */
const LegalDocumentView: React.FC<LegalDocumentViewProps> = ({ document }) => {
  const effectiveDate = new Date(document.effectiveDate).toLocaleDateString(
    undefined,
    { year: "numeric", month: "long", day: "numeric" }
  );

  return (
    <article className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-2 text-grey-10 dark:text-white">
        {document.title}
      </h1>
      <p className="text-sm text-grey-50 dark:text-grey-70 mb-4">
        Version {document.version} · Effective {effectiveDate}
      </p>
      <p className="mb-8 leading-relaxed text-grey-20 dark:text-grey-80">
        {document.summary}
      </p>

      <div className="space-y-6">
        {document.sections.map((section) => (
          <section key={section.heading}>
            <h2 className="text-xl font-semibold mb-2 text-grey-10 dark:text-white">
              {section.heading}
            </h2>
            {section.body.map((paragraph, index) => (
              <p
                key={index}
                className="leading-relaxed text-grey-30 dark:text-grey-70 mb-3"
              >
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </div>
    </article>
  );
};

export default LegalDocumentView;
